import { render, staticRenderFns } from "./GuidedServiceAdd.vue?vue&type=template&id=70ebb410"
import script from "./GuidedServiceAdd.vue?vue&type=script&lang=js"
export * from "./GuidedServiceAdd.vue?vue&type=script&lang=js"
import style0 from "./GuidedServiceAdd.vue?vue&type=style&index=0&id=70ebb410&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports